import React, { useState , useEffect} from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'
import API_CONSTANTS from '../api-constants'



const FinishAccount = () => {
    const search = window.location.search;
    const paramss = new URLSearchParams(search);
  

    const history = useHistory();

    const [error, setError] = useState(false)
    const [tlfNumber, setTlfNumber] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [passwordError, setPasswordError] = useState("");
    const [passwordRepeatError, setPasswordRepeatError] = useState("");
    const [emptyName, setEmptyName] = useState()
    const [emptyNumber, setEmptyNumber] = useState()
    const [emptyPassword, setEmptyPassword] = useState()
    const [noPasswordMatch, setNoPasswordMatch] = useState()
    const isValidName = /^[a-z ,.'-]+$/i
    const [profileCreated, setProfileCreated] = useState(false)
    const [nameError, setNameError] = useState('')
    const [numberError, setNumberError] = useState('')
    const [networkError, setNewtorkError] = useState('')
    const [passwordValidationCheck, setPasswordValidationCheck] = useState(false)
    const [isNumber, setIsNumber] = useState(false)
    const [isUppercase, setIsUppercase] = useState(false)
    const [specialCharacter, setSpecialCharacter] = useState(false)
    const [minimum, setMinimum] = useState(false)

    function encodeBase64(str) {
        return window.btoa(new TextEncoder().encode(str).reduce((data, byte) => data + String.fromCharCode(byte), ""));
    }

    useEffect(() => {
        var re = { 'capital': /[A-Z]/ };
        if (re.capital.test(password) === true) {
            setIsUppercase(true)
        }
        else setIsUppercase(false)
    }, [password])

    useEffect(() => {
        var re = { 'digit': /[0-9]/ };
        if (re.digit.test(password) === true) setIsNumber(true)
        else setIsNumber(false)
    }, [password])

    useEffect(() => {
        var re = { 'specialCharacter': /[_!\"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]/ };

        if (re.specialCharacter.test(password) === true) setSpecialCharacter(true)
        else setSpecialCharacter(false)

        
    }, [password])
  

    useEffect(() => {
        if (password.length > 7) setMinimum(true)
        else setMinimum(false)

    }, [password])

    const validateName = (e) => {
        if (e.target?.value && e.target.value.match(isValidName)) {
            setName(e.target.value)

        }
    }

    const handleNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setTlfNumber(value);
        setNumberError('')
    };

    const handleNameChange = (e) => {
        validateName(e)
        setName(e.target.value)
       // setError(false)
        setNameError('')
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
        setPasswordError('')
        setPasswordValidationCheck(true)
    }

    const handleRepeatPasswordChange = (e) => {
        setPasswordRepeat(e.target.value)
        setPasswordRepeatError('')

    }
    useEffect(() => {
        if (isNumber === true && isUppercase === true && specialCharacter === true && minimum === true) {
            setPasswordValidationCheck(false)
        }
    }, [isNumber, isUppercase, specialCharacter, minimum])

   function handleSubmit ()  {
       
      
        if (name === '' || tlfNumber === '' || password === '' || passwordRepeat === '') {
            setError(true)
        }
        if (password.length && passwordRepeat.length && password !== passwordRepeat) {
            setError(true)
            setNoPasswordMatch('Adgangskode matcher ikke')
            
       }
       if (password.length && passwordRepeat.length && password === passwordRepeat) {
           setNoPasswordMatch('')
           setError(false)
       }
        if (name === '') {

            setNameError('Udfyld venligst navn')
        }
        if (tlfNumber === '') {
            setNumberError('Udfyld venligst telefonnummer')
        }
        if (password === '') {
            setPasswordError('Udfyld venligst adgangskode')
        }
        if (password.length && passwordRepeat === '') {
            setPasswordRepeatError('Udfyld veligst adgangskode igen')
        }
        if (name.length && !name.match(isValidName)) {
            setNameError('Kun bogstav i navnet')
        }
       
        if (tlfNumber !== '' && tlfNumber.length !== 8) {
            setNumberError('Nummeret er forkert')
        }
        else if (isNumber === false || minimum === false || isUppercase === false || specialCharacter === false) {   // check if all 4 password validation is aaplied
            setError(true)
            setPasswordError('Adgangskode matcher ikke krav')
        }
        else if (name.length && name.match(isValidName) && tlfNumber.length === 8) {  // name/tlf varified and password at both places matches
          
            let email = paramss.get('email')
            let uid = paramss.get('guid')
           
            let encoded_password = encodeBase64(password)
          
         
            fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/Create?Email=${email}&Password=${encoded_password}&Name=${name}&Phone=${tlfNumber}&guid=${uid}`, {
                method: "GET",
                headers: {
                    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },  
            })
                .then((res) => res.json())
                .then(result => {
                    //console.log(result, 'result')
                    if (result.result === 1) {
                        setProfileCreated(true)
                        //history.push('/profile', {
                        //    login_info: result.login, transaction: result.transactionsPrYear[0], newsgroup: result.Newsgroups, reservations: result.Reservations
                        //})
                    }
                    else {
                        setError(true)
                        setNewtorkError(result.Message)
                    }
                })

          
        }
    }
    
    document.getElementsByTagName('body')[0].style.backgroundColor = 'black'


    useEffect(() => {
        if (!nameError.length && !numberError.length && !passwordError && !passwordRepeatError) {
            setError(false)
        }
    }, [nameError, numberError, passwordError, passwordRepeatError])

    return (
        <div className='login' style={{ backgroundColor: 'black', padding: '20px 20px 100px 30px ' }}> 
         
            <p className='profile'>Opret profil</p>
            {profileCreated === true ? <p className='emailtext'>Din profil er oprettet, gå tilbage til login </p>
                : 
                <>
                  <p className='emailtext'>Indtast dine oplysninger</p>

           
                  <div className='loginflow'>
                     <label >Email</label>
                     <input className='email-input' value={paramss.get('email')}></input>
                     <label>Navn</label>
                     <input className='email-input' type='text' placeholder='Indtast navn'  onChange={handleNameChange}></input>
                     <label>Telefonnummer</label>
                     <input className='email-input' maxLength='8' type='text' placeholder='Indtast telefonnummer' onChange={handleNumberChange}  value={tlfNumber}></input>
                     <label>Adgangskode</label>
                     <input className='password email-input' type='password' onChange={handlePasswordChange}></input>
                    {passwordValidationCheck === true ?
                     <div className='password-suggestions'>
                         Password should have:
                         <ul>
                            {minimum === false ? <li>Minimum of 8 characters</li> : null}
                            {isUppercase === false ? <li>At least one uppercase letter</li> : null}
                            {isNumber === false ? <li>At least one number</li> : null}
                            {specialCharacter === false ? <li>At least one special character</li> : null}

                         </ul>
                     </div>
                    : null}
                <label>Gentag adgangskode</label>
                <input className='email-input' type='password' onChange={handleRepeatPasswordChange}></input>
                <button type="submit" className='send_btn' onClick={handleSubmit}>Gem</button>

                {error === true ?
                    <div className='error-div'>
                        {networkError && <span>{networkError}</span>}
                        {nameError && <span>{nameError}</span>}
                        {numberError && <span>{numberError}</span>}
                        {passwordError && <span>{passwordError}</span>}
                        {passwordRepeatError && !passwordError && <span>{passwordRepeatError}</span>}
                        {noPasswordMatch && <span>{noPasswordMatch}</span>}
                    </div> : null}
            </div>
                </>
            }
        </div>
    )
}

export default FinishAccount
